{
  "market": {
    "common": {
      "conditions": {
        "new": "New",
        "used": "Used",
        "refurbished": "Refurbished"
      },
      "status": {
        "draft": "Draft",
        "published": "Published",
        "publishedProduct": "Published",
        "disabled": "Disabled",
        "disabledProduct": "Disabled",
        "archived": "Archived",
        "archivedProduct": "Archived"
      },
      "sessionExpired": "Session expired.",
      "sessionExpiredReconnect": "Session expired — please log in again.",
      "sessionExpiredReconnect2": "Session expired. Please log in again.",
      "networkError": "Connection issue. Please try again.",
      "cannotLoad": "Unable to load.",
      "retry": "Retry",
      "loading": "Loading…",
      "back": "Back",
      "cancel": "Cancel",
      "save": "Save",
      "saving": "Saving…",
      "copy": "Copy link",
      "copied": "Copied!",
      "seeMore": "See more",
      "offlineText": "No internet connection"
    },
    "boutiques": {
      "searchPlaceholder": "Search…",
      "headerCount_one": "{{count}} shop",
      "headerCount_other": "{{count}} shops",
      "loadingNormal": "Finding the best shops…",
      "loadingSearch": "Searching…",
      "errorNormal": "Unable to load shops right now.",
      "errorSearch": "Unable to start the search.",
      "emptyNormal": "No shops published yet.",
      "emptySearch": "No shop matches this search.",
      "online": "Online",
      "productsCount_one": "{{count}} product",
      "productsCount_other": "{{count}} products",
      "subscribersCount_one": "{{count}} subscriber",
      "subscribersCount_other": "{{count}} subscribers",
      "visit": "Visit"
    },
    "creerBoutique": {
      "headerTitle": "New shop",
      "subtitle": "Give your shop a name. You'll be able to customize its appearance and add products right after.",
      "nameLabel": "Shop name",
      "namePlaceholder": "E.g.: Wax & Co Workshop",
      "submit": "Create shop"
    },
    "creerProduit": {
      "headerTitle": "New product",
      "createButton": "Create",
      "intro": "Fill in your product listing now. Fields marked with an asterisk are required — the rest can be completed or edited later.",
      "sections": {
        "essential": "Essentials",
        "details": "Details",
        "advanced": "Advanced options",
        "advancedSubtitle": "Promo price, currency, featured status, action buttons",
        "seo": "SEO",
        "seoSubtitle": "How this product appears in search results and shares"
      },
      "fields": {
        "nameLabel": "Product name *",
        "namePlaceholder": "E.g.: Wax bead necklace",
        "priceLabel": "Price ({{currency}}) *",
        "pricePlaceholder": "E.g.: 8000",
        "categoryLabel": "Category",
        "categoryPlaceholder": "Leave blank for \"Other\"",
        "categoryHint": "Category ID — a selector will soon replace this field.",
        "descriptionShortLabel": "Short description",
        "descriptionShortPlaceholder": "A sentence that makes people want it",
        "descriptionLabel": "Full description",
        "descriptionPlaceholder": "Describe the features, materials, dimensions…",
        "brandLabel": "Brand",
        "brandPlaceholder": "E.g.: Handmade, Nike…",
        "conditionLabel": "Condition",
        "stockLabel": "Available stock",
        "stockPlaceholder": "E.g.: 12",
        "stockHint": "Leave blank to start at 0.",
        "skuLabel": "SKU",
        "skuPlaceholder": "E.g.: COL-WAX-001",
        "skuHint": "Must be unique within this shop if provided.",
        "promoPriceLabel": "Promo price",
        "promoPricePlaceholder": "Must be lower than or equal to the regular price",
        "currencyLabel": "Currency",
        "currencyPlaceholder": "XOF",
        "currencyHint": "3-letter ISO code (XOF, EUR, USD…).",
        "featuredLabel": "Feature this product",
        "seoTitleLabel": "SEO title",
        "seoTitlePlaceholder": "Title shown in search results",
        "seoDescriptionLabel": "SEO description",
        "seoDescriptionPlaceholder": "Summary shown below the title in search results"
      },
      "actionButtons": {
        "groupLabel": "Action buttons",
        "whatsapp": "Dedicated WhatsApp button",
        "whatsappField": "WhatsApp number shown for this product only",
        "whatsappPlaceholder": "E.g.: +225 07 00 00 00 00",
        "buy": "\"Buy\" button",
        "buyField": "Link to the page or checkout",
        "learnMore": "\"Learn more\" button",
        "learnMoreField": "Link to more details",
        "call": "\"Call\" button",
        "callField": "Number to call for this product"
      },
      "preview": {
        "label": "Preview",
        "namePlaceholder": "Product name",
        "promoLabel": "Promo price: {{price}}",
        "featuredBadge": "Featured",
        "hint": "Photo, look and actual layout available right after creation."
      }
    },
    "index": {
      "searchPlaceholder": "Search…",
      "headerCount_one": "{{count}} product",
      "headerCount_other": "{{count}} products",
      "loadingNormal": "Loading the marketplace…",
      "loadingSearch": "Searching…",
      "errorNormal": "Unable to load the marketplace.",
      "errorSearch": "Unable to start the search.",
      "emptyNormal": "No products published yet.",
      "emptySearch": "No product matches this search.",
      "newBadge": "New",
      "whatsapp": "WhatsApp",
      "contact": "Contact",
      "contacting": "Opening…",
      "buy": "Buy",
      "learnMore": "Learn more",
      "call": "Call",
      "seeMore": "See more",
      "goToShop": "Go to shop",
      "whatsappMessage": "Hello, I'm interested in \"{{product}}\" on Harmonia Market."
    },
    "reglages": {
      "headerTitle": "Settings",
      "headerSubPro": "Manage your shops, favorites and subscriptions",
      "headerSubStandard": "Your favorites and followed shops",
      "sections": {
        "subscribedShops": "Subscribed shops",
        "favorites": "Favorites",
        "myShops": "My shops"
      },
      "noSubscribedShops": "You're not following any shop yet.",
      "noFavorites": "No products saved yet.",
      "noMyShops": "You don't have a shop yet.",
      "productsCount_one": "{{count}} product",
      "productsCount_other": "{{count}} products",
      "createShopButton": "Create a new shop"
    },
    "gererShop": {
      "notFound": "Shop not found.",
      "sections": {
        "coverPhoto": "Cover photo",
        "publicLink": "Public link",
        "generalInfo": "General information",
        "contacts": "Contacts",
        "location": "Location",
        "seo": "SEO",
        "status": "Shop status",
        "colors": "Colors",
        "typography": "Typography, layout, header",
        "products": "Products",
        "dangerZone": "Danger zone"
      },
      "colorFields": {
        "primary": "Primary color",
        "secondary": "Secondary color",
        "accent": "Accent color",
        "background": "Background color",
        "card": "Card color",
        "button": "Button color",
        "border": "Border color",
        "text": "Text color",
        "link": "Link color"
      },
      "publicLinkHint": "This page is visible to everyone, including people who aren't logged in. Share this link to help people discover your shop.",
      "publicLinkPending": "The link will be available once the shop is saved.",
      "saveError": "Failed to save — please try again.",
      "fields": {
        "taglineLabel": "Tagline",
        "taglinePlaceholder": "A sentence that sums up your shop",
        "taglineHint": "Max 160 characters.",
        "descriptionLabel": "Description",
        "descriptionPlaceholder": "Introduce your shop in detail",
        "whatsappLabel": "WhatsApp Business number",
        "whatsappPlaceholder": "E.g.: +225 07 00 00 00 00",
        "whatsappHint": "Required if the WhatsApp button is enabled below.",
        "showWhatsappBtn": "Show WhatsApp button",
        "showChatBtn": "Show platform chat",
        "contactEmailLabel": "Contact email",
        "contactEmailPlaceholder": "contact@myshop.com",
        "contactPhoneLabel": "Contact phone",
        "contactPhonePlaceholder": "E.g.: +225 07 00 00 00 00",
        "countryLabel": "Country",
        "countryPlaceholder": "E.g.: Côte d'Ivoire",
        "cityLabel": "City",
        "cityPlaceholder": "E.g.: Abidjan",
        "addressLabel": "Address",
        "addressPlaceholder": "Full address",
        "currencyLabel": "Currency",
        "currencyPlaceholder": "XOF",
        "currencyHint": "3-letter uppercase ISO code (XOF, EUR, USD…).",
        "languageLabel": "Language",
        "timezoneLabel": "Time zone",
        "timezonePlaceholder": "E.g.: Africa/Abidjan",
        "seoTitleLabel": "SEO title",
        "seoTitlePlaceholder": "Title shown in search results",
        "seoDescriptionLabel": "SEO description",
        "seoDescriptionPlaceholder": "Summary shown below the title in search results"
      },
      "statusHint": "A \"Published\" shop is publicly visible, including to people who aren't logged in.",
      "typographyPending": "These settings are coming in a future update.",
      "noProducts": "No products yet.",
      "cannotLoadProducts": "Unable to load products.",
      "createProductButton": "Create a product",
      "dangerTitle": "Delete this shop",
      "dangerText": "This action is permanent. All products in this shop will be deleted along with it.",
      "dangerButton": "Delete shop",
      "deleteModal": {
        "title": "Delete \"{{name}}\"?",
        "text": "This action cannot be undone. All products in this shop ({{count}}) will be permanently deleted along with it.",
        "confirmLabel": "To confirm, type the exact shop name:",
        "confirmButton": "Delete permanently"
      }
    },
    "gererProduit": {
      "notFound": "Product not found.",
      "saveButton": "Save",
      "savedBanner": "Changes saved",
      "saveError": "Failed to save — please try again.",
      "sections": {
        "publicLink": "Public link",
        "photos": "Photos",
        "essential": "Essentials",
        "details": "Details",
        "advanced": "Advanced options",
        "seo": "SEO",
        "dangerZone": "Danger zone"
      },
      "publicLinkHint": "This page is visible to everyone, including people who aren't logged in. Share this link to help people discover this product.",
      "publicLinkPending": "The link will be available once the product is saved.",
      "fields": {
        "mainPhoto": "Main photo",
        "photo2": "Photo 2",
        "photo3": "Photo 3",
        "photo3Hint": "Photo 3 requires photo 2 to already be set.",
        "nameLabel": "Product name *",
        "namePlaceholder": "E.g.: Wax bead necklace",
        "priceLabel": "Price ({{currency}}) *",
        "pricePlaceholder": "E.g.: 8000",
        "categoryLabel": "Category",
        "statusLabel": "Status",
        "descriptionShortLabel": "Short description",
        "descriptionShortPlaceholder": "A sentence that makes people want it",
        "descriptionLabel": "Full description",
        "descriptionPlaceholder": "Describe the features…",
        "brandLabel": "Brand",
        "brandPlaceholder": "E.g.: Handmade, Nike…",
        "conditionLabel": "Condition",
        "stockLabel": "Available stock",
        "stockPlaceholder": "E.g.: 12",
        "promoPriceLabel": "Promo price",
        "promoPricePlaceholder": "Must be ≤ regular price",
        "currencyLabel": "Currency",
        "currencyPlaceholder": "XOF",
        "currencyHint": "3-letter ISO code.",
        "featuredLabel": "Feature this product",
        "showChatLabel": "Show platform chat",
        "seoTitleLabel": "SEO title",
        "seoTitlePlaceholder": "Title shown in search results",
        "seoDescriptionLabel": "SEO description",
        "seoDescriptionPlaceholder": "Summary shown below the title"
      },
      "actionButtons": {
        "groupLabel": "Action buttons",
        "whatsapp": "Dedicated WhatsApp button",
        "whatsappHint": "Number specific to this product.",
        "whatsappPlaceholder": "E.g.: +225 07 00 00 00 00",
        "buy": "\"Buy\" button",
        "learnMore": "\"Learn more\" button",
        "call": "\"Call\" button",
        "callPlaceholder": "E.g.: +225 07 00 00 00 00"
      },
      "dangerTitle": "Delete this product",
      "dangerText": "This action is permanent and cannot be undone.",
      "dangerButton": "Delete product",
      "deleteModal": {
        "title": "Delete \"{{name}}\"?",
        "text": "This action cannot be undone.",
        "confirmButton": "Delete"
      }
    },
    "components": {
      "categoryChips": {
        "loading": "Loading categories…",
        "error": "Unable to load categories.",
        "allLabel": "All"
      },
      "colorPicker": {
        "cancel": "Cancel",
        "confirm": "Confirm"
      },
      "detailProduit": {
        "newBadge": "New",
        "inStock": "In stock ({{count}})",
        "outOfStock": "Out of stock",
        "descriptionTitle": "Description",
        "whatsapp": "Contact via WhatsApp",
        "contactSeller": "Contact seller",
        "contacting": "Opening…",
        "buy": "Buy",
        "learnMore": "Learn more",
        "call": "Call",
        "goToShop": "Go to shop",
        "whatsappMessage": "Hello, I'm interested in \"{{product}}\" on Harmonia Market."
      },
      "searchBar": {
        "placeholder": "Search…"
      },
      "shopHeader": {
        "productsLabel": "Products",
        "subscribersLabel": "Subscribers",
        "subscribed": "Subscribed",
        "subscribe": "Subscribe",
        "subscribing": "…"
      },
      "imagePicker": {
        "change": "Change",
        "add": "Add an image",
        "sessionExpired": "Session expired.",
        "uploadError": "Upload failed."
      }
    },
    "produitDetail": {
      "loading": "Loading product…",
      "notFound": "This product doesn't exist or is no longer available.",
      "cannotLoad": "Unable to load this product."
    },
    "boutiqueDetail": {
      "loading": "Loading shop…",
      "notFound": "This shop doesn't exist or is no longer available.",
      "cannotLoad": "Unable to load this shop.",
      "shopNotFound": "Shop not found.",
      "newBadge": "New",
      "productsTitle": "Products",
      "cannotLoadProducts": "Unable to load products.",
      "noProducts": "No products published yet."
    }
  }
}
